<template>
    <v-dialog v-model="show" max-width="390" persistent no-click-animation>
        <v-card>
            <v-card-title primary-title class="headline grey lighten-2 pa-0">
                <v-layout row justify-space-between align-center>
                    <div class="ml-3">{{$t('import') | capitalize}}</div>
                    <v-btn flat icon @click="close()">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-layout>
            </v-card-title>
            <v-card-text>
                <div v-if="uploadSuccess">
                    <table class="upload-result">
                        <tr>
                            <td>Imported Sample</td>
                            <td>{{uploadSuccess.number_of_imported_sample}}</td>
                        </tr>
                        <tr>
                            <td>Imported Intent</td>
                            <td>{{uploadSuccess.number_of_imported_intent}}</td>
                        </tr>
                        <tr>
                            <td>Duplicate Sample</td>
                            <td>{{uploadSuccess.number_of_duplicate_sample}}</td>
                        </tr>
                        <tr>
                            <td>Invalid Intent</td>
                            <td>{{uploadSuccess.number_of_invalid_intent}}</td>
                        </tr>
                    </table>
                    <v-layout>
                        <v-spacer></v-spacer>
                        <v-btn @click="closeAndResolve" class="mx-0" color="primary">OK</v-btn>
                    </v-layout>
                </div>
                <v-form v-model="formValid" ref="form" @submit.prevent="submit" v-else>
                    <input
                        type="file"
                        accept=".xls,.xlsx"
                        ref="file"
                        @input="onFilePicked">
                    <div style="min-height: 30px">
                        <v-layout justify-center align-center v-if="loading" style="height: 100%">
                            <v-icon class="tm-spin">mdi-loading</v-icon>
                        </v-layout>
                        <div class="error-message" v-else>
                            {{errorMessage}}
                        </div>
                    </div>
                    <v-layout>
                        <v-btn class="mx-0" @click="downloadExcelTemplate">download template</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" type="submit" :disabled="loading">
                            {{$t('select')}}
                        </v-btn>
                    </v-layout>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import DialogPromiseFormMixin from '@/modules/fptai/mixins/DialogPromiseFormMixin'
import FormFileMixin from '@/modules/fptai/mixins/FormFileMixin'
import ScenarioService from '@/services/scenario.service'
import NLP_Service from '@/services/nlp.service'

export default {
    name: 'SampleImportExcel',
    mixins: [DialogPromiseFormMixin, FormFileMixin],
    data () {
        return {
            loading: false,
            uploadSuccess: null
        }
    },
    methods: {
        willOpen () {
            this.uploadSuccess = null
        },
        submit () {
            if (!this.file) {
                this.errorMessage = 'You need to pick a file'
                return
            }
            this.errorMessage = ''
            let formData = new FormData()
            formData.append('file', this.file)
            this.loading = true
            NLP_Service.importSamplesExcel(this.$route.params.scenarioId, formData).then(
                result => {
                    this.uploadSuccess = result.data
                },
                e => {
                    if (e.response && e.response.data) {
                        let data = e.response.data
                        this.errorMessage = data.message
                    } else {
                        this.$appService.handleRequestError()(e)
                    }
                }
            ).finally(() => this.loading = false)
        },
        clearForm () {
            this.file = null
            this.fileName = null
            this.errorMessage = ''
            this.$refs.file.value = null
            this.$refs.form.reset()
        },
        downloadExcelTemplate () {
            this.$utils.downloadFileFromUrl('/static/ImportSample.xlsx')
        },
        closeAndResolve () {
            this.promise.resolve(this.uploadSuccess)
            this.close()
            this.clearForm()
        }
    }
}
</script>

<style scoped>
    .error-message {
        color: red;
        height: 100%;
        display: flex;
        align-items: center;
        font-size: 13px;
        font-family: "open sans";
    }

    .upload-result tr td:first-child {
        padding-right: 10px;
    }
</style>
